import { render, staticRenderFns } from "./TradeApp.vue?vue&type=template&id=b8a8d5e2&scoped=true"
import script from "./TradeApp.vue?vue&type=script&lang=js"
export * from "./TradeApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8a8d5e2",
  null
  
)

export default component.exports